/**
 * @fileoverview gRPC-Web generated client stub for usrpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: usrpb/administrator.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.usrpb = require('./administrator_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.AdministratorServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.AdministratorServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.ListAdministratorRequest,
 *   !proto.usrpb.ListAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_ListAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/ListAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.ListAdministratorRequest,
  proto.usrpb.ListAdministratorResponse,
  /**
   * @param {!proto.usrpb.ListAdministratorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.ListAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.ListAdministratorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.usrpb.ListAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.ListAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.listAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/ListAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.ListAdministratorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.ListAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.listAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/ListAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_ListAdministrator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.Administrator,
 *   !proto.usrpb.CreateAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_CreateAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/CreateAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.Administrator,
  proto.usrpb.CreateAdministratorResponse,
  /**
   * @param {!proto.usrpb.Administrator} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CreateAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.usrpb.CreateAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.CreateAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.createAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/CreateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CreateAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.CreateAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.createAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/CreateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_CreateAdministrator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.Administrator,
 *   !proto.usrpb.UpdateAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_UpdateAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/UpdateAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.Administrator,
  proto.usrpb.UpdateAdministratorResponse,
  /**
   * @param {!proto.usrpb.Administrator} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.UpdateAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.usrpb.UpdateAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.UpdateAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.updateAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.UpdateAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.updateAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/UpdateAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_UpdateAdministrator);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.Administrator,
 *   !proto.usrpb.DeleteAdministratorResponse>}
 */
const methodDescriptor_AdministratorService_DeleteAdministrator = new grpc.web.MethodDescriptor(
  '/usrpb.AdministratorService/DeleteAdministrator',
  grpc.web.MethodType.UNARY,
  proto.usrpb.Administrator,
  proto.usrpb.DeleteAdministratorResponse,
  /**
   * @param {!proto.usrpb.Administrator} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.DeleteAdministratorResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.usrpb.DeleteAdministratorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.DeleteAdministratorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.AdministratorServiceClient.prototype.deleteAdministrator =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.AdministratorService/DeleteAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_DeleteAdministrator,
      callback);
};


/**
 * @param {!proto.usrpb.Administrator} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.DeleteAdministratorResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.AdministratorServicePromiseClient.prototype.deleteAdministrator =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.AdministratorService/DeleteAdministrator',
      request,
      metadata || {},
      methodDescriptor_AdministratorService_DeleteAdministrator);
};


module.exports = proto.usrpb;

